import { getResourceTo, openUrlFile, toastNotification } from 'react/utils/utils';
import { actionCreators as bulkDownloadActions } from 'react/api/actions/bulkDownload';
import { actionCreators as headerActions } from 'react/api/actions/header';


class BulkDownloadService {
  constructor(userId) {
    this.userId = userId;
  }

  connect() {
    this.eventSource = new EventSource(`/photoDownload/sse/subscribe?userId=${this.userId}`);

    this.eventSource.onerror = (err) => {
      console.log('EventSource failed:', err);
    };

    this.initListeners();
  }

  closeConnection() {
    this.eventSource.close();
  }

  initListeners() {
    this.eventSource.onmessage = (eventMessage) => {
      if (!this.isEventMessageValid(eventMessage)) return;
      const frameData = JSON.parse(eventMessage.data);
      this.handleEventActions(frameData);
    };
  }

  isEventMessageValid(eventMessage) {
    if (eventMessage.type !== 'message') {
      return false;
    }

    const frameData = JSON.parse(eventMessage.data);

    return !!frameData.status && !!frameData.id;
  }

  handleEventActions(frameData) {
    const { downloads } = GreenmileReduxStore.getState().bulkDownload.toJS();
    const { id: downloadId, status, payload } = frameData;

    const isSameStatus = downloads?.[downloadId]?.status === status;

    if (isSameStatus) return;

    switch (status) {
      case 'ACCEPTED': {
        toastNotification.addToast({
          id: downloadId,
          type: 'success',
          data: {
            title: getResourceTo('alertgenericmodal.header.title.default'),
            description: getResourceTo('bulkdownload.message.acceped'),
          }
        });
        break;
      }
      case 'PROGRESS': {
        GreenmileReduxStore.dispatch(headerActions.selectRightOptionsItem('ActivityCenter', { force: true }));
        GreenmileReduxStore.dispatch(
          bulkDownloadActions.startDownload(downloadId)
        );
        break;
      }
      case 'COMPLETE': {
        GreenmileReduxStore.dispatch(headerActions.selectRightOptionsItem('ActivityCenter', { force: true }));

        GreenmileReduxStore.dispatch(
          bulkDownloadActions.completedDownload(downloadId, payload)
        );
        openUrlFile(payload);
        break;
      }
      case 'NOT_ACCEPTED':
      case 'ERROR': {
        toastNotification.addToast({
          id: downloadId,
          type: 'error',
          data: {
            title: getResourceTo('alertgenericmodal.header.title.default'),
            description: getResourceTo('bulkdownload.message.error'),
          }
        });
        break;
      }
      default:
        console.log(
          'DownloadEventStream sent a message with unknown action',
          frameData
        );
    }
  }

  logError(err) {
    new Monet.Exception.ReturnError(
      this,
      err?.message || 'Error',
      err
    ).console();
  }
}

export default BulkDownloadService;
